import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { HhsgSharedUserApplication } from '../../models/user-application.model';
import { HhsgSharedUserProfile } from '../../models/user-profile.model';
import { HhsgSharedConfigService } from '../../services/config.service';
import { HhsgSharedUserService } from '../../services/user.service';
import { Constants } from '../../utilities/constants.util';
import { HhsgSharedHeaderMenuLink } from './menu/header-menu.component';

@Component({
  selector: 'hhsg-header[hhsg-header]',
  templateUrl: './header.component.html',
  styleUrls: ['header.component.scss']
})
export class HhsgSharedHeaderComponent implements OnInit, OnDestroy {
  @Input() headerLinks: HhsgSharedHeaderMenuLink[];
  @Input() sectionLinks: HhsgSharedHeaderMenuLink[];
  @Input() applicationLinks: HhsgSharedHeaderMenuLink[];
  @Input() isMobile : boolean;
  @Input() showMenuButton: boolean;

  user: HhsgSharedUserProfile = <HhsgSharedUserProfile>{};
  showMenu: boolean;
  selfClick: boolean;
  currUrl: string;
  portalHome: string;

  public documentClickListener: any;

  private _unsubscribe$ = new Subject<void>();

  constructor(public configService: HhsgSharedConfigService,
    public renderer: Renderer2,
    private router: Router,
    private userProfile: HhsgSharedUserService
  ) {
    this.portalHome = configService.appSettings.portalHome;
  }

  ngOnInit(): void {
    this.showMenu = false;

    this.userProfile.getUserProfile().pipe(
      takeUntil(this._unsubscribe$))
      .subscribe((user: HhsgSharedUserProfile) => {
        this.user = user;
      });
  }

  ngOnDestroy(): void {
    this.unbindDocumentClickListener();
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
    this.selfClick = true;

    if (this.showMenu) {
      this.bindDocumentClickListener();
    } else {
      this.unbindDocumentClickListener();
    }
  }

  isAdminApp(app: HhsgSharedUserApplication): boolean {
    return app.abbreviation === Constants.HuronAcceleratorsAbbreviation;
  }

  isCurrPageAdminApp(): boolean {
    return this.router.url.indexOf('/admin') === 0;
  }

  showPortalLink(): boolean {
    return this.isCurrPageAdminApp();
  }

  bindDocumentClickListener() {
    if (!this.documentClickListener) {
      this.documentClickListener = this.renderer.listen('document', 'click', () => {
        if (!this.selfClick) {
          this.showMenu = false;
          this.unbindDocumentClickListener();
        }

        this.selfClick = false;
      });
    }
  }

  unbindDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }
}
